//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

import defaultImage from '../../../../../../../assets/img/image-default.jpg';
import {colors} from '../../../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '55% 45%',
    borderRadius: '.5rem',
    background: 'white',
    height: '90px',
    width: '65px',
    maxWidth: '65px',
    maxHeight: '90px',
  },
  image: {
    padding: '.25rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
    borderBottom: `1px solid ${colors.grey300}`,

    '& img': {
      width: '16px',
      height: '16px',
      objectFit: 'contain',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '.25rem',
    gap: '.35rem',
  },

  title: {
    width: '70%',
    height: 5,
    borderRadius: '.5rem',
    background: colors.grey400,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.125rem',
  },
  line: {
    width: '100%',
    height: 3,
    borderRadius: '.5rem',
    background: colors.grey300,
  },
  button: {
    width: '30%',
    height: 6,
    borderRadius: '.5rem',
    background: colors.grey400,
  },
}));

export default function Layout1() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.image}>
        <img src={defaultImage} alt="mountain icon black and white" />
      </div>
      <div className={classes.content}>
        <div className={classes.title}></div>
        <div className={classes.body}>
          <div className={classes.line}></div>
          <div className={classes.line}></div>
          <div className={classes.line}></div>
        </div>
        <div className={classes.button}></div>
      </div>
    </div>
  );
}
